import React from 'react';
import "styles/components/menu/company/LocationTab.scss";
import Location from 'components/common/Location';

const LocationTab = () => {

    return (
        <section className='LocationTab'>
            <div className="LocationTab-wrapper">
                <div className="title">
                    <span className='fw_bold'>어질인소프트</span>는<br className='lineBreak' />
                    여러분의 <span className='fw_bold'>비즈니스 파트너</span>가 되겠습니다
                </div>
                <div className="map">
                    <Location />
                </div>
                <div className="address">
                    <p className="address-title">본사</p>
                    <div className="address-text">
                        <p>대전 대덕구 대화로 106번길 66, 1002호</p>
                        <p>(대화동, 펜타플렉스)&nbsp;</p>
                        <p><span className="fw_bold">TEL</span> 042-472-2094 | <span className="fw_bold">FAX</span> 042-472-2097</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default React.memo(LocationTab);